import { PurchaseOrderStatus } from '../types/PurchaseOrder.types';
import { GoodsReceiptStatus } from '../types/GoodsReceipt.types';

// Mismos valores que la columna purchase_orders.status del backend.
export const PURCHASE_ORDER_STATUSES: PurchaseOrderStatus[] = [
  'draft',
  'pending_approval',
  'approved',
  'partially_received',
  'received',
  'cancelled'
];

export const PURCHASE_ORDER_STATUS_LABELS: Record<PurchaseOrderStatus, string> = {
  draft: 'Borrador',
  pending_approval: 'Pendiente de aprobación',
  approved: 'Aprobada',
  partially_received: 'Recibida parcialmente',
  received: 'Recibida',
  cancelled: 'Cancelada'
};

// Opciones del filtro de estado del listado (select nativo, como el resto de filtros).
export const PURCHASE_ORDER_STATUS_OPTIONS = [
  { value: 'all', label: 'TODOS LOS ESTADOS' },
  ...PURCHASE_ORDER_STATUSES.map(s => ({ value: s, label: `ESTADO: ${PURCHASE_ORDER_STATUS_LABELS[s].toUpperCase()}` }))
];

export const GOODS_RECEIPT_STATUS_LABELS: Record<GoodsReceiptStatus, string> = {
  partial: 'Parcial',
  complete: 'Completa'
};

export const INCOTERM_OPTIONS = ['EXW', 'FCA', 'CPT', 'CIP', 'DAP', 'DPU', 'DDP', 'FAS', 'FOB', 'CFR', 'CIF'];

export const UNIT_OF_MEASURE_OPTIONS = ['unidades', 'cajas', 'palets', 'kg'];

export const DEFAULT_CURRENCY = 'EUR';

// IVA superreducido de los libros; las líneas que no sean libros se cambian a mano.
export const DEFAULT_TAX_RATE = 4;
